import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../App.css";
import imagen1 from "../img/get_view1.jpg";
import { GrupoContext } from "../GrupoContext";
import Sidebar from "../componenteExtra/SidebarsocioGET";
import { FaLayerGroup, FaUserCheck } from "react-icons/fa";
import Footer from "../componenteExtra/Footer";
import SessionManager from '../componenteExtra/SessionManager';

const Rol = () => {
  const navigate = useNavigate();
  const { grupo, setGrupo } = useContext(GrupoContext);
  const [nombreGet, setNombreGet] = useState("");

  useEffect(() => {
    // Restaurar el estado del contexto desde localStorage
    const savedGrupo = localStorage.getItem("grupo");
    if (savedGrupo) {
      setGrupo(savedGrupo);
    }

    // Obtener el nombre del usuario desde localStorage
    const storedNombreGet = localStorage.getItem("nombre_get");
    if (storedNombreGet) {
      setNombreGet(storedNombreGet);
    }
  }, [setGrupo]);

  useEffect(() => {
    // Guardar el estado del contexto en localStorage
    if (grupo) {
      localStorage.setItem("grupo", grupo);
    }
  }, [grupo]);

  return (
    <div className="app">
      <SessionManager />
      <div className="main-content">
        <Sidebar />
        <div className="main-panel">
          <div className="welcome-message">
            <h2>Bienvenido(a) Socio(a) {nombreGet}</h2>
            <img
              src={imagen1}
              alt="Decorative"
              style={{ width: "100%", height: "auto" }}
            />
          </div>
          <div className="cards-container">
            <div className="card">
              <div className="card-header">
                <FaUserCheck />
                <h3>Visualización de líderes</h3>
              </div>
              <div className="card-subtitle">Acceso Directo</div>
              <div className="card-content">
                En este módulo podrás visualizar que están realizando los
                líderes de los grupos.
              </div>
              <button onClick={() => navigate("/VerLiderSubrogante")}>
                Ver líderes
              </button>
            </div>
            <div className="card">
              <div className="card-header">
                <FaLayerGroup />
                <h3>Visualización de staff</h3>
              </div>
              <div className="card-subtitle">Acceso Directo</div>
              <div className="card-content">
                En este módulo podrás visualizar que están realizando los staff.
              </div>
              <button onClick={() => navigate("/VerAsistentes")}>
                Ver staff
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Rol;
